import z from 'zod';

import {
    CURRENT_VERSION,
    ElementId,
    EmptyChildren,
    emptyChildren,
    UnityElementId,
    Version,
} from '../commons';
import { ELEMENT_TYPES, MIME_TYPES } from '../constants';

export const UnityZattoo = z.object({
    type: z.literal(ELEMENT_TYPES.ZATTOO),
    elementId: UnityElementId,
    templateElement: z.boolean().optional(),
    version: Version,
    src: z.string().optional(),
    originalSrc: z.string().optional(),
    mimetype: z.literal(MIME_TYPES.ZATTOO),
});
type UnityZattoo = z.infer<typeof UnityZattoo>;

export const PlateZattoo = z.object({
    type: z.literal(ELEMENT_TYPES.ZATTOO),
    id: ElementId,
    data: z.object({
        templateElement: z.boolean().optional(),
        src: z.string(),
        originalSrc: z.string(),
        mimetype: z.literal(MIME_TYPES.ZATTOO),
    }),
    children: EmptyChildren,
});
export type ZattooElement = z.infer<typeof PlateZattoo>;

export const ZattooCodec = z.codec(UnityZattoo, PlateZattoo, {
    decode: (value) => ({
        type: value.type,
        id: value.elementId ?? crypto.randomUUID(),
        data: {
            src: value.src ?? '',
            originalSrc: value.originalSrc ?? '',
            mimetype: MIME_TYPES.ZATTOO,
            ...(value.templateElement ? { templateElement: value.templateElement } : {}),
        },
        children: emptyChildren,
    }),
    encode: (value) => ({
        type: value.type,
        elementId: value.id,
        version: CURRENT_VERSION,
        src: value.data.src,
        originalSrc: value.data.originalSrc,
        mimetype: value.data.mimetype,
        ...(value.data.templateElement ? { templateElement: value.data.templateElement } : {}),
    }),
});
